import { render, staticRenderFns } from "./linkAdd.vue?vue&type=template&id=506b56c3&scoped=true&"
import script from "./linkAdd.vue?vue&type=script&lang=js&"
export * from "./linkAdd.vue?vue&type=script&lang=js&"
import style0 from "./linkAdd.vue?vue&type=style&index=0&id=506b56c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b56c3",
  null
  
)

export default component.exports